<script setup lang="ts">
import { Moon, Sun } from '@lucide/vue'
import { useTheme } from '@/app/providers/theme/useTheme'

const { toggleTheme } = useTheme()
</script>

<template>
  <button
    type="button"
    class="w-9 h-9 rounded-lg border border-border text-muted-foreground hover:text-foreground hover:bg-muted flex items-center justify-center transition-all cursor-pointer dark:border-gray-800 dark:bg-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white"
    @click.prevent="toggleTheme"
  >
    <Moon :size="15" class="hidden dark:block" />
    <Sun :size="15" class="dark:hidden" />
  </button>
</template>
